import { CONSTS } from 'config/objectConst'
import { map } from 'nanostores'

import type { PreviewFile } from '../../model/types'

const Error = {
	Size: `File size cannot exceeds ${CONSTS.MESSAGING.MAX_FILE_SIZE_MB} MB.`,
	Upload: 'The upload failed. Please try again'
}

const sizeInMb = (size: number) => size / 1024 / 1024
const checkSizeLimit = (file: File) =>
	sizeInMb(file.size) < CONSTS.MESSAGING.MAX_FILE_SIZE_MB

function recheckLoad(file: PreviewFile) {
	const isResponseInProgress = file.loaded === 100 && !file.attach
	return isResponseInProgress ? 99 : file.loaded
}

const $reUploadMap = map<Record<string, () => Promise<any>>>({})

const addReUpload = (id: string, reupload: () => Promise<any>) =>
	$reUploadMap.setKey(id, reupload)

const cleanReUpload = () => $reUploadMap.set({})

const removeBase64Header = (base64String: string): string =>
	base64String.split(',')[1] || base64String

const toBase64 = (file: File): Promise<string> =>
	new Promise((resolve, reject) => {
		const reader = new FileReader()

		reader.onload = () => resolve(reader.result as string)
		reader.onerror = error => reject(error)

		reader.readAsDataURL(file)
	})

export {
	$reUploadMap,
	addReUpload,
	checkSizeLimit,
	cleanReUpload,
	Error,
	recheckLoad,
	removeBase64Header,
	toBase64
}
